module.exports = __webpack_public_path__ + "img/arrow-d.86d38579.svg";